import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  BASE_URL_SANDBOX,
  SEARCH_PRODUCTS,
  SEARCH_PRODUCTS_ELASTIC,
  BASE_URL_FOR_ELASTIC_SEARCH,
  SEARCH_PRODUCTS_NODE,
  BASE_URL_NODE,
} from '../../../Constants/Config';

const initialState = {
  loading: false,
  searchedProducts: [],
  error: '',
};

export const getSearchedProducts = createAsyncThunk(
  'searchProducts/getSearchedProducts',
  async (data, { getState, rejectWithValue }) => {
    const state = getState();
    let isElasticConnected = state?.allStatesData?.isElasticConnected;
    try {
      if (data.keyword) {
        const body = {
          title: data.keyword,
          merchant_id: data.merchantId,
          order_method: data.orderType,
        };
        let endPint = isElasticConnected
          ? SEARCH_PRODUCTS_ELASTIC
          : SEARCH_PRODUCTS;
        let baseUrl = isElasticConnected
          ? BASE_URL_FOR_ELASTIC_SEARCH
          : BASE_URL_SANDBOX;
        const response = await axios.post(
          // baseUrl + endPint,
          BASE_URL_NODE + SEARCH_PRODUCTS_NODE,
          body,
          { headers: { 'Content-Type': 'multipart/form-data' } },
        );

        if (response.status === 200) {
          // return response.data.result ?? [];
          return response.data.data ?? [];
        } else {
          // If response is not 200, return empty array
          return [];
        }
      } else {
        return [];
      }
    } catch (e) {
      // Return empty array on error (404, 500, etc.) to clear previous results
      return [];
    }
  },
);

const searchProducts = createSlice({
  name: 'searchProducts',
  initialState,
  reducers: {
    clearSearchResults: (state) => {
      state.searchedProducts = [];
      state.error = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSearchedProducts.pending, (state) => {
      state.loading = true;
      // Clear previous results when starting a new search
      state.searchedProducts = [];
    });
    builder.addCase(getSearchedProducts.fulfilled, (state, action) => {
      state.loading = false;
      state.searchedProducts = action.payload;
      state.error = '';
    });
    builder.addCase(getSearchedProducts.rejected, (state, action) => {
      state.loading = false;
      state.searchedProducts = [];
      state.error = action.error.message;
    });
  },
});

export const { clearSearchResults } = searchProducts.actions;
export default searchProducts.reducer;
